import axios from 'axios'

//axios.defaults.baseURL = "http://localhost:64485";
axios.defaults.baseURL = "http://api-la.inspireoneassessment.com";


axios.defaults.headers = { "Content-Type": "application/json" };
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    const token = localStorage.getItem("token");
        if (token) {
          config.headers.Authorization = `bearer ${token}`;
        }
        console.log("request config", config);
        return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  }, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  });



export default axios;